import styled from "styled-components";

export const TableWrap = styled.section``;

export const Table = styled.table`
  position: relative;
  width: 100%;
  margin-bottom: 3rem;
  border-top: 0.1rem solid rgba(0, 0, 0, 0.1);
`;

export const TableHeader = styled.tr`
  background: #fafafa;
`;

export const Column = styled.th`
  padding: 0.7rem 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 11px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.1);
  user-select: none;
  transition: all 0.15s linear;
  .tooltip {
    opacity: 0;
  }
  :hover {
    background: #f6f6f6;
  }
  :hover .tooltip {
    opacity: 0.85;
  }
`;

export const ToolTip = styled.span`
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  bottom: 100%;
  left: 0px;
  border: 0.1rem solid rgba(0, 0, 0, 0.1);
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1.414rem;
  padding-right: 1.414rem;
  margin-bottom: 1rem;
  text-align: left;
  background: #fafafa;
  border-radius: 4px;
  z-index: 9999;
  pointer-events: none;
  transition: all 0.15s linear;
`;

export const Item = styled.td`
  padding: 1.2rem 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.1);
`;

export const Loading = styled.p`
  width: 50px;
  height: 50px;
  margin: 40px auto;
  border: 3px solid #e6e6e6;
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: spin 0.8s linear 0s infinite;
`;

export const Message = styled.p`
  margin: 50px;
  text-align: center;
`;

export const getDate = (dateStr: string) => {
  const date = new Date(dateStr);
  return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
};
